<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <r-widget-control [control]="firstnameControl">
      <d-date-picker
        [nzShowTime]="true"
        nzFormat="yyyy-MM-dd HH:mm:ss"
        [name]="config.name"
        ngDefaultControl
        #firstnameControl="ngModel"
        [(ngModel)]="config.value"
        [required]="config.required"
        [disabled]="config.disabled"
        style="width: 100%"
      ></d-date-picker>
    </r-widget-control>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.effective">
    <app-effective-display [config]="config"> </app-effective-display>
  </nz-col>
</nz-row>
